import EditableList from "@/components/editableList";
import LangSelect from "@/components/langSelect";
import StmtTypeCreatePane from "@/views/statement/components/stmtTypeCreatePane";

export default {
    name: "StatementTypeList",
    props: [],
    components: {
        EditableList,
        LangSelect
    },
    data() {
        return {
            lang: ""
        };
    },
    computed: {
        curLanguage() {
            return this.$store.state.statement.statementType.curLanguage;
        },
        stmtTypeList() {
            return this.$store.state.statement.statementType.stmtTypeList.map(type => ({
                ...type,
                label: type.name,
                subLabel: type.statementNum
            }));
        },
        selectedType() {
            return this.$store.state.statement.statementType.selectedType;
        }
    },
    watch: {
        lang: function(value) {
            this.$store.commit("statement/updateCurLanguage", value);
            this.$store.dispatch("statement/queryStmtTypeList");
            this.$store.dispatch("statement/queryStmtList", { language: value });
        }
    },
    mounted() {
        this.$store.dispatch("statement/queryStmtTypeList");
    },
    methods: {
        handleTypeSelectChange(typeId) {
            this.$store.commit("statement/updateSelectedType", typeId);
            this.$store.dispatch("statement/queryStmtList", { type_id: typeId, page: 0 });
        },
        stmtTypeSelected(record) {
            this.handleTypeSelectChange(record.id);
        },
        stmtTypeHeaderSelected() {
            this.handleTypeSelectChange("");
        },
        stmtTypeOperate({ actionType, record }) {
            if (actionType === "edit") {
                const { id, newLabel } = record;
                const params = {
                    type_id: id,
                    type_name: newLabel
                };
                this.$store.dispatch("statement/updateStmtType", params);
            }

            if (actionType === "delete") {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: this.$t("zhiji.common.deleteConfim") + record.label + this.$t("zhiji.form.ma"),
                        confirm: () => {
                            this.$store.dispatch("statement/deleteStmtType", record.id);
                        }
                    }
                });
            }
        },
        addHandler() {
            this.$store.dispatch("zhiji/showModal", {
                type: StmtTypeCreatePane,
                data: {
                    language: this.$store.state.statement.statementType.curLanguage,
                    typeName: ""
                }
            });
        }
    }
};
